import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { SharesTitle } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useShareTitleListPage } from '../context/ShareTitleListPageContext';
import ShareTitleTableRow from './ShareTitleTableRow';

const ShareTitleTableBody: FC = () => {
  const { t } = useTranslate();
  const { data } = useShareTitleListPage();

  const hasData = data.shareTitles?.length > 0;

  const rows = data.shareTitles!.map(
    (sharesTitle: SharesTitle, index: number) => (
      <ShareTitleTableRow
        key={sharesTitle._id ?? `title-row-${index}`}
        index={index}
        title={sharesTitle}
      />
    )
  );

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataMessage={t('NoTitlesMessage')}
    />
  );
};

export default ShareTitleTableBody;
